export enum ConciliacaoStatus {
    PENDENTE = "PENDENTE",
    CONCLUIDO = "CONCLUIDO",
    DIVERGENTE = "DIVERGENTE",
    NAO_SE_APLICA = "NAO_SE_APLICA"
}

export interface EtapaConciliacaoStatus {
  etapa: string;
  status: ConciliacaoStatus;
  observacao?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PropostaFinanceira {
  id: string;
  proposalId: string;
  shortHash: string;
  statusConciliacao: ConciliacaoStatus;
  dataCriacaoProposta: string;
  valorLiberado: number;
  valorParcela: number;
  dataPagamentoSeguro: string;
  quantidadeParcelaSeguro: number;
  valorLiberadoSeguro: number;
  dataPagamentoBanco: string;
  quantidadeParcelaBanco: number;
  valorLiberadoBanco: number;
  quantidadeParcela: number;
  numeroCcb: string;
  dataPagamento: string;
  valorSeguro: number;
  valorIof: number;
  valorDesconto: number;
  processorId?: string;
  creditPromoterId?: string;
  creditPromoterName?: string;
  corbanId?: string;
  corbanName?: string;
  sellerId?: string;
  sellerName?: string;
  commercialManagerId?: string;
  commercialManagerName?: string;
  insuranceCompanyId?: string;
  insuranceCompanyName?: string;
  etapasConciliacao?: EtapaConciliacaoStatus[];
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export type ViewModeType = "list" | "detail";